import React, { useEffect } from 'react';
import {
  CarInformationSelector,
  CurrentStepContentSelector,
  CurrentStepSelector,
  FitStatusSelector,
  HasLoadedFromCookieSelector,
  InitialDataSelector,
  TranslationsSelector,
} from '../../Selectors/FitAssistantSelectors';
import { setHasFinishedSelection, setShowFitAssistant } from '../../Slices/FitAssistantSlice.ts';
import { resetFitAssistant } from '../../Thunks/Reset.ts';
import { useAppDispatch, useAppSelector } from '../../Store/store.ts';
import { trackFit, trackView, trackFitNoRacks, trackOpenEmpty } from '../../Analytics/Adobe.ts';
import Buttons from '../Buttons/Buttons.tsx';
import PrimaryButton from '../Buttons/PrimaryButton.tsx';
import SecondaryButton from '../Buttons/SecondaryButton.tsx';
import FitAssistantVariation from '../../Enums/FitAssistantVariation.ts';
import FitAssistantStatus from '../../Enums/FitAssistantStatus.ts';
import { CloseType } from '../../Types/Tracking.ts';

import './Confirmed.less';

const Confirmed = () => {
  const dispatch = useAppDispatch();
  const currentStep = useAppSelector(CurrentStepSelector);
  const carInformation = useAppSelector(CarInformationSelector);
  const currentStepContent = useAppSelector(CurrentStepContentSelector);
  const initialData = useAppSelector(InitialDataSelector);
  const translations = useAppSelector(TranslationsSelector);
  const hasLoadedFromCookie = useAppSelector(HasLoadedFromCookieSelector);
  const fitAssistantStatus = useAppSelector(FitStatusSelector);

  useEffect(() => {
    trackView(
      initialData.FitAssistantVariation,
      currentStep,
      initialData.IsYearFirst,
      carInformation,
      hasLoadedFromCookie
    );

    dispatch(setHasFinishedSelection(true));
  }, []);

  const trackConfirmedClick = (closeType: CloseType, clickLink?: string) => {
    if (fitAssistantStatus === FitAssistantStatus.ConfirmedNoRacks) {
      trackFitNoRacks(
        initialData.FitAssistantVariation,
        currentStep,
        initialData.IsYearFirst,
        carInformation,
        closeType,
        clickLink
      );
    } else {
      trackFit(
        initialData.FitAssistantVariation,
        currentStep,
        initialData.IsYearFirst,
        carInformation,
        closeType,
        clickLink
      );
    }
  };

  const onClickPrimary = () => {
    dispatch(setShowFitAssistant(false));
    trackConfirmedClick('Close');
  };

  const onClickSecondary = () => {
    trackConfirmedClick('Reset');
    trackOpenEmpty(initialData.FitAssistantVariation, initialData.IsYearFirst, [], initialData.Steps[0].Parameter);
    dispatch(resetFitAssistant(true));
  };

  const onClickContent = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    const linkElement = (e.target as HTMLElement).closest('a') as HTMLAnchorElement;
    if (linkElement) {
      trackConfirmedClick('Read more', linkElement.href);
      window.location.href = linkElement.href;
    }
  };

  return (
    <>
      <div>
        <div
          className="mb-6"
          dangerouslySetInnerHTML={{
            __html: currentStepContent?.Text ?? '',
          }}
        />
        {currentStepContent?.ImageUrl && (
          <div className="cms-image-wrapper d-flex justify-content-center w-100">
            <img src={currentStepContent?.ImageUrl} alt={currentStepContent?.ImageAlt} />
          </div>
        )}
        {initialData.FitAssistantVariation === FitAssistantVariation.RooftopTents &&
          currentStepContent?.ResultContent && (
            <div className="result-content mt-11">
              <h5 className="mb-4">{translations.readMore}</h5>
              <div className="items">
                {currentStepContent?.ResultContent?.map((result, index) => (
                  <div key={index}>
                    <a href={result.Link} target="_blank" rel="noopener noreferrer" onClick={onClickContent}>
                      <img src={result.ImageUrl} alt={result.ImageAlt} className="mb-4" />
                      {result.LinkText}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          )}
      </div>
      <Buttons visible>
        <PrimaryButton visible text={translations.confirm} onClick={onClickPrimary} />
        <SecondaryButton visible text={translations.reset} onClick={onClickSecondary} />
      </Buttons>
    </>
  );
};

export default Confirmed;
